import { FC, RefObject, useContext, useRef, useEffect, useState } from 'react';
import { CollapseProps } from '.';
import { CollapseContext } from './collapseContext';

const CollapseMenu: FC<CollapseProps> = ({
  children,
  as: tag = 'div',
  className,
}) => {
  const { open, showAll } = useContext(CollapseContext);
  const ref: RefObject<HTMLElement> = useRef(null);
  const [height, setHeight] = useState<any>(0);

  useEffect(() => {
    setHeight(open ? ref.current?.scrollHeight ?? 'auto' : 0);
  }, [open, showAll,children]); 

  const Tag = tag;

  return (
    <Tag
      ref={ref}
      className={`transition-all overflow-hidden ${className ?? ''}`}
      style={{ height }}
    >
      {children}
    </Tag>
  );
};

export default CollapseMenu;
